import { variants, ReadonlyTextFieldInputTheme } from '../ReadonlyTextFieldInputStyles.css';
import { multiVariantStyles } from './ReadonlyTextFieldInputVariants.css';

const ReadonlyTextFieldInputStableTheme: ReadonlyTextFieldInputTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { ReadonlyTextFieldInputStableTheme };
